import "bootstrap/dist/css/bootstrap.min.css";
import { Navbar } from "./components/Navbar";
import { Route, Switch } from "react-router-dom";
import "./App.css";
import About from "./pages/About";
import Project from "./pages/Project";
import Contact from "./pages/Contact";
import Home from "./pages/Home";
import Footer from "./components/Footer";
import ScrollToTop from "./components/SmoothScrollbar";
import Layout from "./pages/Layout";

function App() {
  return (
    <>
      <Navbar />
      <ScrollToTop />
      {/* <Particles
        className="particles-canvas"
        params={{
          particles: {
            number: {
              value: 80,
              density: {
                enable: true,
                value_area: 900,
              },
            },
          },
          interactivity: {
            events: {
              onhover: {
                enable: true,
                mode: "repulse",
              },
            },
          },
          shape: {
            type: "star",
            stroke: {
              width: 8,
              color: "#f9ab00",
            },
          },
        }}
      ></Particles> */}

      <Route exact path="/">
        <Home />
      </Route>
      <Switch>
        <Route path="/about">
          <About />
        </Route>
        <Route path="/projects">
          <Project />
        </Route>
        <Route path="/contact">
          <Contact />
        </Route>
        <Route path="/layout">
          <Layout />
        </Route>
      </Switch>
      <Footer />
    </>
  );
}

export default App;
